<template>
  <v-container>
      <v-row justify="center" alignment="center" no-gutters class="heading-row">
          <v-col cols="1" class="rays-left">
          </v-col>
          <v-col cols="auto" class="text-white heading-block">
              <div class="green-slant"><h1 class="center-text arla-strong" :class="{'small-heading': $vuetify.breakpoint.smAndDown}">{{this.langData.early.title}}</h1></div>
          </v-col>
          <v-col cols="1" class="rays-right"> 
          </v-col>
      </v-row>
      <v-row justify="center" class="text-green">
        <v-col cols="12" md="8">
          <p class="text-center"><b v-html="this.langData.early.body"></b></p>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-green">
        <v-col cols="auto">
          <span class="rays">
            <v-btn outlined class="pink-button submit-button" color="#e93e8f" href="https://www.arlafoods.co.uk/brands/lactofree/milk/" target="_blank">{{this.langData.early.cta}}</v-btn>
          </span>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Early',
  props: ['langData'],
  data: () => ({
    valid: false,
    lashesRight : {src:require('../assets/lashesRight.png')},
    lashesLeft : {src:require('../assets/lashesLeft.png')},
    lashHeight: '54px',
  }),
};
</script>
